import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { GbUnauthenticatedShellComponent } from './gb-unauthenticated-shell/gb-unauthenticated-shell.component'
import { GbDashboardCoreFeatureModule } from 'libs/gb-dashboard/core/feature/src/lib/gb-dashboard-core-feature.module'

@NgModule({
  imports: [CommonModule, GbDashboardSharedUiModule, GbDashboardCoreFeatureModule],
  declarations: [GbUnauthenticatedShellComponent],
  exports: [GbUnauthenticatedShellComponent],
})
export class GbDashboardAccountUiModule {}
